/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'could': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M511.504 958.878c-243.067 0-440.095-197.028-440.095-440.096S268.44 78.687 511.504 78.687c243.042 0 440.095 197.028 440.095 440.095.001 243.069-197.052 440.096-440.095 440.096zM153.926 518.782c0 197.486 160.095 357.579 357.578 357.579 83.863 0 160.82-29.092 221.796-77.415L231.343 296.962c-48.32 61.003-77.417 137.959-77.417 221.819zm357.578-357.575c-83.863 0-160.818 29.092-221.819 77.415l501.958 501.957c48.349-60.974 77.439-137.932 77.439-221.796-.001-197.485-160.093-357.578-357.579-357.578z"/>'
  }
})
